const normalizeText = (text: string): string => (
  text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
);

export default normalizeText;
